import { Typography } from '@mui/material';

import { convertUTCToLocal } from 'src/utils/format-time';

// ----------------------------------------------------------------------

type RowCellDateProps = {
  value: any;
  fieldKey: string;
};

// ----------------------------------------------------------------------

export function RowCellDate({ value, fieldKey }: RowCellDateProps) {
  const timeStampFields = ['callDateTs', 'date', 'due_date'];
  const updatedValue = timeStampFields.includes(fieldKey) ? value * 1000 : value;
  const formattedDate = convertUTCToLocal(updatedValue);

  return (
    <>
      <Typography
        variant="body2"
        sx={{
          color: 'primary.primary',
          textDecoration: 'none',
          cursor: 'pointer',
          transition: 'all 0.2s ease-in-out',
          '&:hover': {
            color: 'primary.dark',
            transform: 'translateX(2px)',
          },
        }}
      >
        {formattedDate?.date}
      </Typography>

      <Typography
        variant="body2"
        sx={{
          ml: 2,
          fontSize: '0.75rem',
          color: 'text.secondary',
          transition: 'all 0.2s ease-in-out',
        }}
      >
        {formattedDate.time}
      </Typography>
    </>
  );
}
